
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorPlayersNavigationVue from "@/components/administrator/players/navigation.vue";
import AppAdministratorPlayersRootListIndexVue from "@/views/app/administrator/players/root/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorPlayersNavigationVue,
    AppAdministratorPlayersRootListIndexVue,
  },
})
export default class AppAdministratorPlayersRootIndexVue extends Vue {
}
